const DEFAULT_API_BASE_URL = 'https://mall-portal.xigfor.com'

const normalizeBaseUrl = (url = '') => url.replace(/\/+$/, '')

export const API_BASE_URL = normalizeBaseUrl(
  process.env.VUE_APP_API_BASE_URL || DEFAULT_API_BASE_URL
)

export const buildApiUrl = (path = '') => {
  if (/^https?:\/\//i.test(path)) {
    return path
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${API_BASE_URL}${normalizedPath}`
}
